import React from 'react';
import { domMax, LazyMotion } from 'motion/react';

function MotionProvider({
    children,
}: {
    children: React.ReactNode;
}): React.ReactElement {
    return <LazyMotion features={domMax}>{children}</LazyMotion>;
}

export default MotionProvider;
